import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { Provider } from 'react-redux';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import store from './store';
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://d4020b966ac44f60b665441d190cccf4@o1334194.ingest.sentry.io/6600467",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}
const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
